"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
tslib_1.__exportStar(require("@uifabric/foundation"), exports);
//# sourceMappingURL=Foundation.js.map


//////////////////
// WEBPACK FOOTER
// ./~/office-ui-fabric-react/lib-commonjs/Foundation.js
// module id = 1039
// module chunks = 0